import {
  LEASE_DEALS_STATE_PATH,
  LEASE_DEALS_MONTHLY_199_PATH,
  LEASE_DEALS_MAKE_PATH,
  LEASE_DEALS_MAKE_CITY_STATE_PATH,
} from 'site-modules/shared/constants/lease-deals/routes';

export function getCmsPathForPage({ matchPath, pathname }) {
  const HIDDEN_GEMS_STATE_CMS_PATH = '/lease-deals/hidden-gems/lease-deals/state';
  const HIDDEN_GEMS_MONTHLY_CMS_PATH = '/lease-deals/hidden-gems/car-leasing/monthly-199-lease-deals/index';
  const HIDDEN_GEMS_MAKE_CMS_PATH = '/lease-deals/hidden-gems/make-lease-deals/index';
  const HIDDEN_GEMS_MAKE_CITY_STATE_CMS_PATH = '/lease-deals/hidden-gems/make-lease-deals/state';

  const matchPathToCmsPathMap = {
    [LEASE_DEALS_STATE_PATH]: HIDDEN_GEMS_STATE_CMS_PATH,
    [LEASE_DEALS_MONTHLY_199_PATH]: HIDDEN_GEMS_MONTHLY_CMS_PATH,
    [LEASE_DEALS_MAKE_PATH]: HIDDEN_GEMS_MAKE_CMS_PATH,
    [LEASE_DEALS_MAKE_CITY_STATE_PATH]: HIDDEN_GEMS_MAKE_CITY_STATE_CMS_PATH,
  };

  if (matchPath in matchPathToCmsPathMap) {
    return matchPathToCmsPathMap[matchPath];
  }

  return `/lease-deals/hidden-gems${pathname.replace(/\/$/, '')}/index`;
}
